import urls from "../../config/urls";
import { Api, getPutParams, getGetParams } from "../../utils";

export function fetchNotificatonApi() {
  return Api.fetch(urls.notification, getGetParams());
}

export function updateNotificationApi(payload) {
  return Api.fetch(
    `${urls.notification}/${payload.bpId}`,
    getPutParams(payload)
  );
}
